<template>
<div>
	 <v-dialog title="新增课程价格" v-model="hideShow" width="600" persistent scrollable>
		<v-card class="fc-dialog-card ft-dialog">

			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-tag-plus-outline</v-icon></span><div><h2>新增课程价格套餐</h2><p>选择课程，配置套餐金额与课时</p></div><v-spacer/><v-btn icon aria-label="关闭新增课程价格套餐" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-select v-model="add.courseModel" :items="selectCourseList" label="请选择课程" item-text="courseName"
							item-value="id" return-object outlined dense color="#d9363e" aria-label="请选择课程"></v-select>
					</v-col>
					<v-col cols="12" class="d-flex">
						<v-text-field label="价格套餐名称" v-model="add.priceModel.priceName" dense outlined color="#d9363e" aria-label="价格套餐名称"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field type="number" label="课程价值" v-model="add.priceModel.courseAmount" dense outlined color="#d9363e" aria-label="课程价值"></v-text-field>
					</v-col>
					<template v-if="add.courseModel && add.courseModel.consumeType=='1'">
						<v-col cols="12" sm="6">
							<v-text-field type="number" label="课时数" v-model="add.priceModel.addHours" dense outlined color="#d9363e" aria-label="课时数"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field type="number" label="直减金额" v-model="add.priceModel.reduceAmount" dense outlined color="#d9363e" aria-label="直减金额"></v-text-field>
						</v-col>
					</template>
					<template v-if="add.courseModel && add.courseModel.consumeType=='2'">
						<v-col cols="12">
							<v-text-field type="number" label="赠送金额" v-model="add.priceModel.giveAmount" dense outlined color="#d9363e" aria-label="赠送金额"></v-text-field>
						</v-col>
					</template>
					<v-col cols="12">
						<v-text-field label="套餐简介" v-model="add.priceModel.briefDesc" dense outlined color="#d9363e" aria-label="套餐简介"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitAdd" :loading="add.submiting" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

 </div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-price-create",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
				}
			},
			
		},
		data(){
			this.submitAdd = utils.throttle(this.submitAdd, 500)
			return {
				shopId:"",
				add: {
					submiting:false,
					courseModel:null,
					priceModel:{
						courseId:"",
						priceName:"",
						courseAmount:"",
						reduceAmount:"",
						giveAmount:"",
						addHours:"",
						briefDesc:""
					}
				},
				hideShow:this.show,
				selectCourseList:[]
				
			}
		},
		mounted() {
			console.log("course-price-create mounted");
			this.shopId = utils.getCurrentShopId();
			this.getCourseListForSelect();
		},
		methods:{
			submitAdd(){		
				console.log("submit clicked");
				if (!this.add.courseModel) {
					this.$noty.error('请选择课程');
					return
				}
				
				if (!this.add.priceModel.priceName) {
					this.$noty.error('套餐名称不能为空');
					return
				}
				
				if (!this.add.priceModel.courseAmount) {
					this.$noty.error('课程金额不能为空');
					return
				}
				
				if (!utils.isDecimal(this.add.priceModel.courseAmount)){
					this.$noty.error('课程金额格式错误,最多只能输入2位小数的正数');
					return
				}
				
				const consumeType = this.add.courseModel.consumeType;
				
				if (consumeType == "1"){
					// 按课时扣费
					if(!this.add.priceModel.addHours){
						this.$noty.error('课时数不能为空');
						return
					}
					if (this.add.priceModel.reduceAmount){
						if (!utils.isDecimal(this.add.priceModel.reduceAmount)){
							this.$noty.error('直减金额格式错误,最多只能输入2位小数的正数');
							return
						}
					}
				}else{
					// 按金额扣费
					
					if (this.add.priceModel.giveAmount){
						if (!utils.isDecimal(this.add.priceModel.giveAmount)){
							this.$noty.error('赠送金额格式错误,最多只能输入2位小数的正数');
							return
						}
					}
				}
				
				
				this.add.submiting = true;

				// api
				const that = this;
				let url = `/financial/course/price/create`;
				let postData = {...this.add.priceModel};
				postData.courseId = this.add.courseModel.id;
				postData.consumeType = consumeType;
				console.log(postData);
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							
							that.$emit("success","");
							that.submiting = false;
							return;
						} else {
							that.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.submiting = false;
						that.$noty.error('网络请求失败');
					}
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			getCourseListForSelect() {
				
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/financial-tools.scss"></style>
